import { DeliveryAccess } from "@customer-app/state/stores/delivery";
import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";
import { LoyaltyStoreAccess } from "../store";

export const useShowActiveSubscriberMultiplier = () => {
  const flags = useSmartrrFlags();
  const activeDeliveries = DeliveryAccess.useHasActiveDeliveries();
  const activeSubscriberMultiplier = LoyaltyStoreAccess.useActiveSubscriberMultiplier();

  return flags.activeSubscriberRewardsMultiplier && activeDeliveries && !!activeSubscriberMultiplier;
};
